import React, {Component} from "react";
import {Button, Form, Image} from "react-bootstrap";
import $ from "jquery";
import * as utils from "../../../utils.js";

export default class FormDatosTestamentoHermana extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Variables para controlar el field set de si y no
            checkedgoodTestament: false,
            checkedvitalTestament: false,
      checkedgoodAdministrator: false,

      // Variables para controlar si estan rellenos o no los campos del pdf

      goodTestament: false,
      vitalTestament: false,

      // Variable que comprueba si esta el campo vacio o va a ser eliminado

      addGoodTestament: true,
      addVitalTestament: true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.DatosTestamentoPut = this.DatosTestamentoPut.bind(this);
  }

  // Comprueba si hay documentos
  componentDidMount() {
    if (this.props.DatosMonja.datosTestamento) {
        let checkedgoodTestament = !!(this.props.DatosMonja.datosTestamento.goodTestament && this.props.DatosMonja.datosTestamento.goodTestament !== "");
        let checkedvitalTestament = !!(this.props.DatosMonja.datosTestamento.vitalTestament && this.props.DatosMonja.datosTestamento.vitalTestament !== "");
        let checkedgoodAdministrator = this.props.DatosMonja.datosTestamento.nameAdministrator && this.props.DatosMonja.datosTestamento.nameAdministrator !== "";
        this.setState({
            checkedgoodTestament: checkedgoodTestament,
            goodTestament: checkedgoodTestament,
            checkedvitalTestament: checkedvitalTestament,
            vitalTestament: checkedvitalTestament,
            checkedgoodAdministrator: checkedgoodAdministrator,
        });
    }
  }

  // Función para hacer el put de los datos testamento
  DatosTestamentoPut(event) {
    event.preventDefault();
    let $this = $(this);
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);

    // Si borramos y añadimos solo modificamos el pdf por lo que no hacemos el delete
    if (event.target["goodTestament"]) {
      if (event.target["goodTestament"].value) {
        this.setState({
          goodTestament: true,
        });
      }
    }

    if (event.target["vitalTestament"]) {
      if (event.target["vitalTestament"].value) {
        this.setState({
          vitalTestament: true,
        });
      }
    }

    //Para añadir al formulario el campo del nombre vacio del administrador
    if (!event.target["nameAdministrator"]) {
      form.append("nameAdministrator", "");
    }

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/testamento",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // Caso de exito hace un set al estado de hermana detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setDatosTestamento(response);

        // Eliminamos el pdf en fucnion del estado del componente y si ha sido eliminado por el usuario
        if (!$this[0].state.goodTestament && !$this[0].state.addGoodTestament) {
          utils.callAjaxGet("DELETE", process.env.REACT_APP_API_URL + "/download/hermanas/" + $this[0].props.DatosMonja.sister.id + "/testamentoBienes", $this[0].props.ErrorHandling);
          $this[0].props.nullField("goodTestament", "datosTestamento");
        }

        //Eliminamos el pdf en funcion del estado del componente
        if (!$this[0].state.vitalTestament && !$this[0].state.addVitalTestament) {
          utils.callAjaxGet("DELETE", process.env.REACT_APP_API_URL + "/download/hermanas/" + $this[0].props.DatosMonja.sister.id + "/testamentoVital", $this[0].props.ErrorHandling);
          $this[0].props.nullField("vitalTestament", "datosTestamento");
        }
        $this[0].setState({ addGoodTestament: true, addVitalTestament: true }); // Por si se hacen varias eliminaciones a la vez
      })
      .fail($this[0].props.ErrorHandling);
  }

  // Función que controla que campos mostrar en el formulario
  handleChange(event) {
    if (event.target.name === "goodTestamentField") {
      this.setState({
        checkedgoodTestament: !this.state.checkedgoodTestament,
      });
    }
    if (event.target.name === "vitalTestamentField") {
      this.setState({
        checkedvitalTestament: !this.state.checkedvitalTestament,
      });
    }
    if (event.target.name === "goodAdministrator") {
      this.setState({
        checkedgoodAdministrator: !this.state.checkedgoodAdministrator,
      });
    }
  }

  //If para saber si la variable de estado es true mostralo o si es false no mostrarlo
  render() {
    // Si el field set esta a sí y hay un documento se muestra el documento
    // Si el field set esta a sí y no hay un documento se muestra el insertar un documento
    // Si el field set esta a no, no se muestra nada
    const goodTestament = this.state.checkedgoodTestament ? (
      this.state.goodTestament ? (
        <Form.Group>
          <a href={process.env.REACT_APP_API_URL + "/download/hermanas/" + this.props.DatosMonja.sister.id + "/testamentoBienes"} target="_blank" rel="noreferrer">
            PDF Testamento de Bienes
          </a>
          <Button
            variant="light"
            className="ml-3"
            onClick={() =>
              this.setState({
                goodTestament: false,
                addGoodTestament: false,
                checkedgoodTestament: true,
              })
            }
          >
            <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
          </Button>
        </Form.Group>
      ) : (
        <Form.Group>
          <Form.Label>Testamento de Bienes</Form.Label>
          <Form.Control type="file" name="goodTestament" maxLength="45" />
        </Form.Group>
      )
    ) : null;

    const vitalTestament = this.state.checkedvitalTestament ? (
      this.state.vitalTestament ? (
        <Form.Group>
          <a href={process.env.REACT_APP_API_URL + "/download/hermanas/" + this.props.DatosMonja.sister.id + "/testamentoVital"} target="_blank" rel="noreferrer">
            PDF Testamento Vital
          </a>
          <Button
            variant="light"
            className="ml-3"
            onClick={() =>
              this.setState({
                vitalTestament: false,
                addVitalTestament: false,
                checkedvitalTestament: true,
              })
            }
          >
            <Image width="25" fluid src={"/svg/trash-outline.svg"}></Image>
          </Button>
        </Form.Group>
      ) : (
        <Form.Group>
          <Form.Label>Documento del Testamento Vital *</Form.Label>
          <Form.Control type="file" name="vitalTestament" maxLength="45" />
        </Form.Group>
      )
    ) : null;

    const goodAdministrator = this.state.checkedgoodAdministrator ? (
      <Form.Group>
        <Form.Group>
          <Form.Label>Nombre *</Form.Label>
          <Form.Control
            required
            type="text"
            name="nameAdministrator"
            maxLength="45"
            autoComplete="nope"
            defaultValue={this.props.DatosMonja.datosTestamento ? this.props.DatosMonja.datosTestamento.nameAdministrator : null}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Apellidos *</Form.Label>
          <Form.Control
            type="text"
            name="surnameAdministrator"
            maxLength="90"
            autoComplete="nope"
            defaultValue={this.props.DatosMonja.datosTestamento ? this.props.DatosMonja.datosTestamento.surnameAdministrator : null}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Parentesco *</Form.Label>
          <Form.Control
            type="text"
            name="relationshipAdministrator"
            maxLength="100"
            autoComplete="nope"
            defaultValue={this.props.DatosMonja.datosTestamento ? this.props.DatosMonja.datosTestamento.relationshipAdministrator : null}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>País *</Form.Label>
          <Form.Control
            type="text"
            name="countryAdministrator"
            maxLength="35"
            autoComplete="nope"
            defaultValue={this.props.DatosMonja.datosTestamento ? this.props.DatosMonja.datosTestamento.countryAdministrator : null}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Provincia *</Form.Label>
          <Form.Control
            type="text"
            name="provinceAdministrator"
            maxLength="45"
            autoComplete="nope"
            defaultValue={this.props.DatosMonja.datosTestamento ? this.props.DatosMonja.datosTestamento.provinceAdministrator : null}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Dirección *</Form.Label>
          <Form.Control
            type="text"
            name="addressAdministrator"
            maxLength="120"
            autoComplete="nope"
            defaultValue={this.props.DatosMonja.datosTestamento ? this.props.DatosMonja.datosTestamento.addressAdministrator : null}
          />
        </Form.Group>
      </Form.Group>
    ) : null;

    // Lo que devuelve el componente con los default values obtenidos del props
    return (
      <Form className=" p-4" onSubmit={this.DatosTestamentoPut} id="MyForm" autoComplete="off">
        <fieldset>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Group>
            <Form.Label>Testamento de Bienes *</Form.Label>

            <Form.Check type="radio" label="Sí" name="goodTestamentField" checked={this.state.checkedgoodTestament} onChange={this.handleChange} />
            <Form.Check type="radio" label="No" name="goodTestamentField" onChange={this.handleChange} disabled={this.state.goodTestament} checked={!this.state.checkedgoodTestament} />
            {goodTestament}
          </Form.Group>
        </fieldset>

        <fieldset>
          <Form.Group>
            <Form.Label>Testamento Vital *</Form.Label>

            <Form.Check type="radio" label="Sí" name="vitalTestamentField" checked={this.state.checkedvitalTestament} onChange={this.handleChange} />
            <Form.Check type="radio" label="No" name="vitalTestamentField" onChange={this.handleChange} disabled={this.state.vitalTestament} checked={!this.state.checkedvitalTestament} />
            {vitalTestament}
          </Form.Group>
        </fieldset>

        <fieldset>
          <Form.Group>
            <Form.Label>Administrador de Bienes *</Form.Label>

            <Form.Check type="radio" label="Sí" name="goodAdministrator" checked={this.state.checkedgoodAdministrator} onChange={this.handleChange} />
            <Form.Check type="radio" label="No" name="goodAdministrator" onChange={this.handleChange} disabled={this.state.vitalTestament} checked={!this.state.checkedgoodAdministrator} />
            {goodAdministrator}
          </Form.Group>
        </fieldset>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO
            name="Testamento y administración de bienes"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
